import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

export default function () {
    Swiper.use([Autoplay, Navigation, Pagination]);

    new Swiper('#swiper', {
        autoplay: {
            delay: 5000
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '#swiper-slider-button-next',
            prevEl: '#swiper-slider-button-prev'
        },
        grabCursor: true,
        slidesPerView: 2,
        spaceBetween: 50, // should correspond with
        loop: true, // requires number of slider >= slidesPerView * 2
        breakpoints: {
            280: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            1200: {
                slidesPerView: 2,
                spaceBetween: 50, // should correspond with
            }
        }
    });
}
